<template>
  <div class="summary">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Tarea')">
        <el-row>
          <el-col :md="14">
            <h2>Tarea
              <br>
              <h1 class="nameTask">{{taskName}}</h1>
            </h2>
          </el-col>
          <el-col :md="10">
            <StepsInventario v-bind:step="2"/>
          </el-col>
        </el-row>

        <el-row>
          <el-col :md="24">
            <h3 class="a-left">{{$t('Procedimiento')}}</h3>
          </el-col>
          <el-col :md="24">
            <div>{{ procedure || 'Sin procedimiento asociado' }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :md="24">
            <br>
            <br>
            <h3 class="a-left">Riesgos</h3>
            <el-tabs v-model="activeTab">
              <el-tab-pane :label="$t('Vista Tabla')" name="table">
                <keep-alive>
                  <InventarioTable :risks="risks" />
                </keep-alive>
              </el-tab-pane>
              <el-tab-pane :label="$t('Vista Bowtie')" name="bowtie">
                <keep-alive>
                  <div class="listado-riesgos">
                    <div class="riesgo" v-for="(risk, i) in risks" v-bind:key="i">
                      <InventarioBowtie :risk="risk" />
                      <br>
                    </div>
                  </div>
                </keep-alive>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <br><br>
        <div class="text-right">
          <el-button type="info" @click="previousStep" size="medium" class="big-submit">{{$t('Anterior')}}</el-button>
          <el-button type="primary" :loading="isLoading" @click="save" class="big-submit" size="medium">
            {{$t('Continuar')}}
          </el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import StepsInventario from '@/components/StepsInventario.vue';
import InventarioTable from '@/components/InventarioTable.vue';
import InventarioBowtie from '@/components/vistaBowtie.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SummaryStep',
  data() {
    return {
      isLoading: false,
      activeTab: 'table',
    };
  },
  components: {
    StepsInventario,
    InventarioTable,
    InventarioBowtie,
  },
  computed: {
    taskName() {
      const indexTask = this.$store.getters.selectedIndexTask;
      return this.$store.getters.inventario.tareas[indexTask].nombre;
    },
    procedure() {
      const indexTask = this.$store.getters.selectedIndexTask;
      return this.$store.getters.inventario.tareas[indexTask].procedimiento;
    },
    risks() {
      const indexTask = this.$store.getters.selectedIndexTask;
      return this.$store.getters.inventario.tareas[indexTask].riesgos;
    },
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
    }),
  },
  methods: {
    previousStep() {
      this.$router.push({ name: 'secondStep' });
    },
    save() {
      this.$store.dispatch('createOrUpdateDraft')
        .then((response) => {
          if (response.success) {
            const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
            this.$router.push({
              path: url,
            });
            this.$notify({
              duration: 3000,
              title: 'Atención',
              message: 'Cambios guardados exitosamente',
              type: 'success',
            });
          } else {
            this.$alert(response.message, this.$t('Atención'), {
              type: 'error',
            });
          }
        });
    },
  },
};
</script>

<style scoped>
  .text-back {
    color: #000;
  }
  .a-left {
    text-align: left;
  }
  .detalles-inventario {
    margin-bottom: 60px;
  }
  label {
    color: rgb(131, 138, 142);
    font-size: 14px;
  }
  .el-input {
    margin-top: 5px;
  }
</style>
